var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSysInfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "33px",
    viewBox: "0 0 32 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_sys_info") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_sys_info",
    fill: "#2371D6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C24.8124492,0 32,7.18677541 32,15.9995 C32,24.8122246 24.8124492,32 16,32 C7.18755078,32 1.42108547e-14,24.8122246 1.42108547e-14,15.9995 C1.42108547e-14,7.18677541 7.18755078,0 16,0 Z M16,2.4609231 C8.5344666,2.4609231 2.46184613,8.53473329 2.46184613,15.9995 C2.46184613,23.4652667 8.5344666,29.5380769 16,29.5380769 C23.4645335,29.5380769 29.5381539,23.4652667 29.5381539,15.9995 C29.5381539,8.53473329 23.4645335,2.4609231 16,2.4609231 Z M16,13.7385707 C17.0189363,13.7385707 17.8458846,14.5655448 17.8458846,15.584513 L17.8458846,22.4772976 C17.8458846,23.4962657 17.0189363,24.3232399 16,24.3232399 C14.9810637,24.3232399 14.1541154,23.4962657 14.1541154,22.4772976 L14.1541154,15.584513 C14.1541154,14.5655448 14.9810637,13.7385707 16,13.7385707 Z M16,7.6767601 C17.0869321,7.6767601 17.9688769,8.55873254 17.9688769,9.64669854 C17.9688769,10.7336646 17.0869321,11.615637 16,11.615637 C14.912068,11.615637 14.0311231,10.7336646 14.0311231,9.64669854 C14.0311231,8.55873254 14.912068,7.6767601 16,7.6767601 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSysInfo);
export default __webpack_public_path__ + "static/media/ic_sys_info.15e2ba3f0f2014843e7a5a6debc8044f.svg";
export { ForwardRef as ReactComponent };